import React from 'react';
import { Popover } from 'antd';

import addResponsable from '../../../assets/img/gantt/assignee-new.png';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { trackingEvent } from '../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';
import { constraintTypeEditor } from '../../../assets/js/field_config/editor-inline-gantt';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const constraintTypeCol = (gantt, t, fieldNoPermission, triggerSetter, cursorCustomStyle) => ({
  name: 'constraint_type',
  label: 'Tipo de Restricción',
  align: 'center',
  width: 122,
  template: (activity) => {
    let constraint_type_label = 'As Soon As Possible';
    let hasChild = false;
    let isOdd = false;
    if (gantt.oddColsConfig) isOdd = gantt.oddColsConfig.constraint_type;

    if (activity) {
      hasChild = gantt.hasChild(activity.id);
      constraint_type_label = gantt.locale.labels[activity.constraint_type]
        ? gantt.locale.labels[activity.constraint_type]
        : 'As Soon As Possible';
    }

    const htmlH = getStringHidden(constraint_type_label, 'constraint_type');

    let retStr = `
            <div 
                title="${constraint_type_label}" 
                class="constraint-type-container-style cut-text-and-dot ${isOdd ? 'odd-col' : 'non-odd-col'}" 
                style="font-weight: ${hasChild ? '600' : '100'}"> 
            `;

    retStr = `${retStr}
                <span class="string-v">${constraint_type_label}</span>
                ${htmlH}
            </div>`;

    return retStr;
  },
  resize: true,
  editor: gantt ? constraintTypeEditor(gantt) : null,
  hide: !isColumnVisibleByDefault('constraint_type'),
  data_type: 'array/string',
  from_values: [
    {
      color: '#E50101',
      value: 'fnlt',
      label: 'Finish No Later Than',
      description: 'LEAN debit status means...',
      weigth: 7
    },
    {
      color: '#E50101',
      value: 'fnet',
      label: 'Finish No Earlier Than',
      description: 'LEAN debit status means...',
      weigth: 6
    },
    {
      color: '#E50101',
      value: 'asap',
      label: 'As soon As Possible',
      description: 'LEAN debit status means...',
      weigth: 5
    },
    {
      color: '#586666',
      value: 'alap',
      label: 'As late As Possible',
      description: 'LEAN debit status means...',
      weigth: 4
    },
    {
      color: '#34AF00',
      value: 'snet',
      label: 'Start No Earlier Than',
      description: 'LEAN can status means...',
      weigth: 3
    },
    {
      color: '#2C3421',
      value: 'snlt',
      label: 'Start No Later Than',
      description: 'LEAN debit status means...',
      weigth: 2
    },
    {
      color: '#F59D04',
      value: 'mso',
      label: 'Must Start On',
      description: 'LEAN debit status means...',
      weigth: 1
    },
    {
      color: '#F59D04',
      value: 'mfo',
      label: 'Must Finish On',
      description: 'LEAN debit status means...',
      weigth: 0
    }
  ],
  groupable: false,
  groupable_switch: ['1 → N', 'N → 1'],
  orderable: true,
  orderable_switch: ['1 → N', 'N → 1'],
  filterable: true,
  onrender: (task, node) => {
    // @ts-ignore
    const gantt = window.to_use_react_gantt;
    const from_values = [
      {
        color: '#586666',
        value: 'asap',
        label: 'As soon As Possible',
        description: 'LEAN debit status means...',
        weigth: 5
      },
      {
        color: '#586666',
        value: 'alap',
        label: 'As late As Possible',
        description: 'LEAN debit status means...',
        weigth: 4
      },
      {
        color: '#586666',
        value: 'snet',
        label: 'Start No Earlier Than',
        description: 'LEAN can status means...',
        weigth: 3
      },
      {
        color: '#586666',
        value: 'snlt',
        label: 'Start No Later Than',
        description: 'LEAN debit status means...',
        weigth: 2
      },
      {
        color: '#586666',
        value: 'fnlt',
        label: 'Finish No Later Than',
        description: 'LEAN debit status means...',
        weigth: 7
      },
      {
        color: '#586666',
        value: 'fnet',
        label: 'Finish No Earlier Than',
        description: 'LEAN debit status means...',
        weigth: 6
      },
      {
        color: '#586666',
        value: 'mso',
        label: 'Must Start On',
        description: 'LEAN debit status means...',
        weigth: 1
      },
      {
        color: '#586666',
        value: 'mfo',
        label: 'Must Finish On',
        description: 'LEAN debit status means...',
        weigth: 0
      }
    ];

    if (!gantt) return;
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.constraint_type;
    }
    const column = 'constraint_type';
    /** To avoid complex code, just use uncontrolled dom elements through a ref */
    let popRef = null;
    let statusObject = from_values?.find((e) => e.value === task[column]);
    if (!statusObject) {
      statusObject = from_values[0];
    }
    const disabled = task?.type === 'project' || task.progress === 100;
    const boldField = task?.type === 'project';

    const element_new = (
      <div className="opacity-hover-style">
        <span className="add-responsable-new">
          <img width="10" src={addResponsable} />
        </span>
      </div>
    );

    const element_actual = (
      <div className="subcontract-border cut-text-and-dot">
        <span
          style={{
            cursor:
              disabled || fieldNoPermission ? 'not-allowed' : 'pointer',
            fontWeight: boldField ? 'bold' : 'normal'
          }}
          className="text-subcontract">
          <div style={{ display: 'none' }} className="pre-text-subcontract">
            {' '}
            &nbsp;
          </div>
          <span style={{ position: 'relative' }}>
            {statusObject?.label}
          </span>
        </span>
      </div>
    );

    const constraint_type_element = (
      <div>{statusObject ? element_actual : element_new}</div>
    );

    const changeOption = (option) => {
      if (popRef) {
        gantt.lastUpdatedColumn = 'constraint_type';
        task.undo_constraint_type = task.constraint_type;
        task.undo_constraint_date = task.constraint_date;
        task.undo_start_date = task.start_date;
        task.undo_end_date = task.end_date;
        gantt.updateTask(task.id);
        task[column] = option.value;
        task.real_constraint_type = option.value;
        task.last_constraint = option.value;

        if (['asap', 'alap'].includes(option.value)) {
          task.constraint_date = null;
        }

        if (['snet', 'snlt', 'mso'].includes(option.value)) {
          task.constraint_date = task.start_date;
        }
        if (['fnet', 'fnlt', 'mfo'].includes(option.value)) {
          task.constraint_date = task.end_date;
        }

        gantt.updateTask(task.id);
        gantt.resetTotalSlackCache();
        gantt.autoSchedule();
        delete task.undo_constraint_type;
        popRef.tooltip.setState({ visible: false });

        gantt.resetLinksStateWithTimeout &&
          gantt.resetLinksStateWithTimeout();
      }
      trackingEvent(
        'activity_constraint_type_assignment',
        {
          ...getBasicAmplitudEventProperties(),
          activity_name: task?.text,
          activity_id: task?.id,
          activity_index: task?.correlative_id
        },
        AMPLITUDE_SERVICE
      );
    };

    return (
      <div className={`react-dhtmlx ${isOdd ? 'odd-col' : 'non-odd-col'}`}>
        {!disabled ? (
          <Popover
            placement="bottom"
            ref={(r) => {
              popRef = r;
            }}
            overlayClassName="popover-subcontract custom-gantt-subcontract"
            className="popover-subcontract react-dhtmlx custom-gantt-subcontract"
            content={
              <div
                className="subcontracts-options"
                style={{
                  maxHeight: '240px'
                }}>
                {from_values.map((option) => (
                  <span
                    className="item-gantt"
                    key={option.value}
                    onClick={() => changeOption(option)}>
                    <div className="subcontract-border cut-text-and-dot  subcontract-border__hover">
                      <div className="text-subcontract cut-text-and-dot text-subcontract-item">
                        {option.label}
                      </div>
                    </div>
                  </span>
                ))}
              </div>
            }
            trigger={triggerSetter}>
            {constraint_type_element}
          </Popover>
        ) : (
          constraint_type_element
        )}
      </div>
    );
  }
});

export default constraintTypeCol;